export const personalizationCallOut = ({ zIndex }) => ({
  position: "relative",
  zIndex,
});

export const callout =
  ({ backgroundColor, zIndex, desktopPosition, mobilePosition }) =>
  ({ isDesktop }) => {
    return {
      display: "flex",
      flexDirection: "column",
      backgroundColor,
      border: "1px solid #000000",
      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.25)",
      borderRadius: "8px",
      backgroundPosition: "50% 50%",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      position: "absolute",
      zIndex,
      transform: "translate(-50%, -50%)",
      flexGrow: "1",
      flexShrink: "1",
      overflow: "hidden",

      ...(isDesktop ? desktopPosition : mobilePosition),
    };
  };

export const calloutImage = ({ backgroundImageUrl }) => ({
  backgroundImage: `url("${backgroundImageUrl}")`,
  backgroundPosition: "50% 50%",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  borderRadius: "0px 0px 1px 1px",
  flexGrow: "1",
  flexShrink: "1",
  position: "relative",
});

export const bottomTextContainer = ({ isDesktop }) => ({
  borderRadius: "4px 4px 0px 0px",
  height: isDesktop ? "36px" : "18px",
  backgroundColor: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const bottomText = ({ isDesktop }) => ({
  padding: "10px",
  fontFamily: "roboto",
  fontSize: isDesktop ? "12px" : "10px",
  lineHeight: "1.4",
  letterSpacing: "0.1em",
  textAlign: "center",
  color: "black",
});
